import React, { useState, useCallback } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { IconPlus } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { useAuth } from '@/context/AuthContext';

const CreateMenu: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleCreateTicket = useCallback(() => {
    setAnchorEl(null);
    navigate('/tickets?openCreate=true');
  }, [navigate]);

  const handleCreateFileService = useCallback(() => {
    setAnchorEl(null);
    navigate('/new-file-service');
  }, [navigate]);

  if (user?.userType !== 'customer') {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<IconPlus size="18" />}
        onClick={handleOpen}
        size="small"
      >
        {t('createMenu.button')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleCreateTicket}>
          {t('createMenu.newTicket')}
        </MenuItem>
        <MenuItem onClick={handleCreateFileService}>
          {t('createMenu.newFileService')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default CreateMenu;




